var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{attrs:{"value":_vm.progress,"max":_vm.max,"animated":"","variant":_vm.v}})}
var staticRenderFns = []

export { render, staticRenderFns }